/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import ToggleBtn from "../SidebarComponent/ToggleBtn/ToggleBtn";
import "./Nav.css";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { openLogoutModal } from "../../redux/EngageTranslation/EngageTranslationAction";
import { getSessionData } from "../../services/auth/AuthAPI";
import translateLogo from "../../assets/img/engage_translate_logo.svg";
// import { logoutUser } from "../../services/auth/AuthAPI";

function AuthNav(props: any) {
  const user = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData"))));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [onQuickTextTranslate, setOnQuickTextTranslate] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname.split("/");

    if (url[2] === "quick-text-translate") {
      setOnQuickTextTranslate(true);
    } else {
      setOnQuickTextTranslate(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    getSessionData().then((res) => {
      if (!res.getIdToken().payload["cognito:groups"].includes("engage-translate-admins" || null)) {
        setIsAdminLoggedIn(false);
      } else {
        setIsAdminLoggedIn(true);
      }
    });
  }, []);

  return (
    <nav className="navbar navbar-expand-lg d-flex flex-column  position-sticky top-0">
      <div className="container-fluid d-flex align-items-center ">
        <div className="navbar-nav  gap-3 align-items-center">
          <ToggleBtn />
          <a
            className="navbar-brand "
            href="/documents">
            <img
              src={translateLogo}
              alt="translate Logo"
              className="navbar-img-edit"
            />
          </a>
          <div className="nav-items-edit">
            <div
              className="nav-item"
              onClick={() => navigate("/")}>
              <button className="nav-link">
                <div className="d-flex align-items-center gap-">
                  <div style={{ fontSize: "14px", marginTop: "-1px" }}>ENGAGE AI</div>
                </div>
              </button>
            </div>

            {/* <div className="nav-item">
              <button className="nav-link  ">
                <div className="d-flex align-items-center gap-1">{isAdminLoggedIn && <div style={{ fontSize: "14px", marginTop: "-1px" }}>SETTINGS</div>}</div>
              </button>
            </div> */}

            <div
              className="nav-item"
              onClick={() => navigate("quick-text-translate")}>
              <button className={`nav-link ${onQuickTextTranslate ? "active" : ""}`}>
                <div style={{ fontSize: "14px", marginTop: "-1px" }}>QUICK TEXT TRANSLATE</div>
              </button>
            </div>
          </div>
        </div>

        <div
          className="collapse navbar-collapse flex-grow-0 "
          id="navbarNavAltMarkup">
          <div className="dropdown">
            <button
              className="user-container  "
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <div className="d-flex align-items-center gap-1">
                <span className="material-symbols-outlined">person</span>
                <span className="user-edit">{user.idToken.payload.name}</span>
                <span className="material-symbols-outlined">arrow_drop_down</span>
              </div>
            </button>

            <div
              className="dropdown-menu drop-menu-container "
              aria-labelledby="dropdownMenuButton">
              <a
                className="dropdown-item dropdown-item-customize"
                onClick={() => dispatch(openLogoutModal())}>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="collapse navbar-collapse w-100 px-4 border-bottom"
        id="navbarNavAltMarkup"></div>
    </nav>
  );
}

export default AuthNav;
